import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmDeadlineVO {
  id?: number
  caseId: number
  deadlineType: string
  title: string
  dueDate: string
  remindDaysBefore?: number
  status?: string
  caseTitle?: string
  firmCaseNo?: string
}

export interface FirmDeadlinePageReq extends PageParam {
  caseId?: number
  deadlineType?: string
  status?: string
  upcomingOnly?: boolean
}

export const FirmDeadlineApi = {
  create: (data: FirmDeadlineVO) => request.post({ url: '/lawyer/firm/deadline/create', data }),
  update: (data: FirmDeadlineVO) => request.put({ url: '/lawyer/firm/deadline/update', data }),
  delete: (id: number) => request.delete({ url: '/lawyer/firm/deadline/delete?id=' + id }),
  page: (params: FirmDeadlinePageReq) =>
    request.get<PageResult<FirmDeadlineVO>>({ url: '/lawyer/firm/deadline/page', params }),
  complete: (id: number) => request.put({ url: '/lawyer/firm/deadline/complete?id=' + id })
}
